module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Dante_MT_Std__And__20pt__And__Centre_Alignment__And__Spacing_After__And__Spacing_Before__And__Page_Break"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("THE DRAINS SUSPECTED")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("LADY BRASH TO SPINLOVE")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("Dear Mr. Spinlove,")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Justification__And__Left_Indent__And__Right_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-size": "1.20em"
    }
  }, [_vm._v("It is dreadfully close here, the house always smells stuffy and the drains must be ")]), _c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-style": "italic",
      "font-size": "1.20em"
    }
  }, [_vm._v("very")]), _c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-size": "1.20em"
    }
  }, [_vm._v(" bad for I have tried disinfectant but it only makes it worse instead of better so something will have to be done or I am afraid we shall all be ")]), _c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-style": "italic",
      "font-size": "1.20em"
    }
  }, [_vm._v("affected")]), _c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-size": "1.20em"
    }
  }, [_vm._v("! There was a ")]), _c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-style": "italic",
      "font-size": "1.20em"
    }
  }, [_vm._v("horrid")]), _c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-size": "1.20em"
    }
  }, [_vm._v(" smell the other day and I am sure it was the scullery sink or something and it might get into the larder though I told them always to keep it shut as tainted food is ")]), _c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-style": "italic",
      "font-size": "1.20em"
    }
  }, [_vm._v("not pleasant")]), _c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-size": "1.20em"
    }
  }, [_vm._v(" and I am ")]), _c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-style": "italic",
      "font-size": "1.20em"
    }
  }, [_vm._v("most")]), _c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-size": "1.20em"
    }
  }, [_vm._v(" particular even the dogs are not allowed to and it is specially at night though Leslie will not believe me.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Justification__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("How peaceful after all the stormy weather we have been having!")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("Thursday. \tYours sincerely,")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_6_CLOSEPAR_"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text_Indent_2"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("Lady Brash complained of a bad smell on an earlier occasion before the house was finished. That, after some trouble, was found to be the pungent aroma of the new, untreated oak, which the lady did not like. Spinlove apparently does not answer this letter. He was, as we know, going to the house a day or two later.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std_Italic__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("SPINLOVE TO GRIGBLAY")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("Dear Sirs, \t6.3.26.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Justification__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("Yes, I set aside your letter of 31st January, as the work was then not completed and you were not entitled to a certificate. The matter has since escaped my attention, and the Statement covered by your letter cannot be found in this office. I am at a loss to understand how you justify a certificate for £3,500, and shall be glad if you will let me have a copy of the missing Statement.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("Yours faithfully,")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std_Italic__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text_Indent_2"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("A lame business! Spinlove seems to have put aside the Statement without looking at it, or he would have questioned it at the time.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std_Italic__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("SPINLOVE TO GRIGBLAY")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("Dear Sirs, \t9.3.26.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Justification__And__Left_Indent__And__Right_Indent"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("I enclose specification for work in completing entrance road. I ought to have your estimate of the extra cost, as Sir Leslie wants to know this.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Justification__And__Left_Indent__And__Right_Indent__OPENPAR_2_CLOSEPAR_"
  }, [_c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-size": "1.20em"
    }
  }, [_vm._v("I am annoyed to find that wet gets into the chimneys and shows on the second-floor breasts. I could see nothing wrong with the listings, and Bloggs assures me the soakers were properly lapped and turned up—in fact, I saw the work being done. It is, therefore, evident that the water strikes through the cement and runs down behind the upturned edge of the soakers, and I learn from Bloggs that the cement was ")]), _c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-style": "italic",
      "font-size": "1.20em"
    }
  }, [_vm._v("not")]), _c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-size": "1.20em"
    }
  }, [_vm._v(" waterproofed with Puddlyte. The listings will have to be replaced in Puddlyte cement as specified. The work should be put in hand at once, a small bit at a time, as weather allows; and care taken to keep tarpaulins rigged to prevent rain getting in.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Justification__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("Lady Brash tells me she finds the house “stuffy,” and that she has not felt well since she went to live in it, and that two of the servants have been unwell. She suspects something is wrong with the drains. This is not possible, but, as a fact, did the District Surveyor test the whole of the drains and give you a formal certificate of acceptance of the sanitary work? If so, kindly send me the certificate by return.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("Yours faithfully,")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std_Italic__And__12pt__And__Italic__And__Justification__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("It seems that Spinlove employed lead soakers laid in with the tiles and turned up against the brickwork where roof slopes butt up against chimneys, but replaced the usual lead cover-flashings, turned into the brick joints and covering the upturned edges of the soakers, with cement fillets in the angle between tile and chimney-face. These “listings” are a perfectly sound, water-tight device, although they are associated with the tradition of humble buildings—rather than of important works of architecture. Spinlove, we remember, had several knowing ideas for a sham medieval roof which he could not get carried out; but he seems to have had his own way in this matter.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Justification__And__Left_Indent__And__Right_Indent__OPENPAR_2_CLOSEPAR_"
  }, [_c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-style": "italic",
      "font-size": "1.20em"
    }
  }, [_vm._v("The Local Government Board’s model bye-laws secure that all drains shall be planned on established scientific principles of sanitation, so that architects are relieved of the preoccupation of trying to save money by following ideas of their own, and inspections and tests by District Councils’ Surveyors reduce-in practice though not in law-the architect’s responsibility for seeing that the work is properly carried out. Spinlove’s letter suggests that he is in need of evidence of this official approval to enforce the assurances he offered Lady Brash of the soundness of the drains. His urgency will be readily understood by those who read The Honeywood File. If Lady Brash gets the idea into her head that something is wrong with the drains, nothing less than a course of hypodermic injections is likely ever to get it out again.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std_Italic__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("GRIGBLAY TO SPINLOVE")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("Dear Sir, \t10.3.26.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Justification__And__Left_Indent__And__Right_Indent__OPENPAR_2_CLOSEPAR_"
  }, [_c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-size": "1.20em"
    }
  }, [_vm._v("The whole of the drains were duly tested with water and the pipes with smoke by Mr. Gallop, the drain Inspector; and the whole were inspected on two occasions by the District Surveyor, Mr. Potch, whose certificate of approval we enclose. We are sure there is nothing wrong as the work was done under the supervision of Bloggs; and as Mr. Potch could not find fault with it no one else is likely to be able to. [")]), _c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-style": "italic",
      "font-size": "1.20em"
    }
  }, [_vm._v("This letter was evidently dictated by Grigblay.")]), _c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-size": "1.20em"
    }
  }, [_vm._v("]")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Justification__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("As regards the listings, this is not in our opinion the best method of flashing to chimneys; but we have no reason to think that the work at Honeywood is defective, as it was carefully carried out to your instructions. We have respectfully to point out that Puddlyte to listings was not, as you state, ordered by you. Puddlyte cement is specified for bedding and jointing weathered brick members only.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Justification__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("We do not know to what the damp in chimney-breasts is due, but Mr. Grigblay expects to be that way on Friday and will take the opportunity.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Justification__And__Left_Indent__And__Right_Indent__OPENPAR_2_CLOSEPAR_"
  }, [_c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-size": "1.20em"
    }
  }, [_vm._v("We have noted your provisional acceptance by telephone to-day of our estimate of ")]), _c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-size": "1.10em"
    }
  }, [_vm._v(" £")]), _c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-size": "1.20em"
    }
  }, [_vm._v("64 12s. for remaking entrance road. We have ordered the pitching and enclose details of our measurements and rates on which our estimate is based for you to check. ")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Justification__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("Yours faithfully,")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std_Italic__And__12pt__And__Italic__And__Justification__And__Left_Indent__And__Right_Indent"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("Spinlove is making a muddle of things. He ought to have asked the quantity surveyor what the approximate value of the work on entrance road was) and left it to be measured and valued at settling-up. Apparently he accepted Grigblay’s estimate so that the work could be put in hand, but subject to measurements being checked and rates agreeing with the Contract Schedule. This, however, is a task for the quantity surveyor, and in any case Spinlove had no business to learn what those rates are, for the priced bills of quantities, which constitute the Contract schedule, tire properly kept under seal. A builder has a right to expect that they will be so kept, as otherwise the architect is in a position to vary the contract in the interests of his client, and unprofitably for the builder, by substituting work for which the builder has included a low price for that for which he has allowed a good one. Such a proceeding by a building-owner is manifestly unfair and, by an architect, dishonest; for the architect is, by the terms of the contract, constituted arbiter between client and builder.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std_Italic__And__12pt__And__Italic__And__Justification__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("It is not usual for the District Sanitary Inspector to test with smoke, but he has the right to do so and there were reasons why Mr. Potch, the District Surveyor, should instruct him to so test at Honeywood.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std_Italic__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("SPINLOVE TO LADY BRASH")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("Dear Lady Brash, \t11.3.26.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Justification__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("As I promised, I enclose the formal official certificate of the Local District Surveyor showing that the whole of the drains conform with the regulations of the Local Government Board and Public Health Acts; and that the pipes, both below and above ground, have been subjected to smoke and water tests; and that the whole of the work was approved as sound and to his satisfaction. I hope that this will entirely banish any doubts you may have. May I assure you that I have none whatever myself?. As I told you, I personally overlooked the whole of the arrangements, and you may rest assured that everything is safe and sound. Even if a defect had developed in the drains since they were tested and passed, which is unbelievable, it could not by the remotest possibility lead, as you imagine, to contamination of the air in the house. With kind regards,")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("Yours sincerely,")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Justification__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Justification__And__Left_Indent__And__Right_Indent__OPENPAR_2_CLOSEPAR_"
  }, [_c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-style": "italic",
      "font-size": "1.20em"
    }
  }, [_vm._v("P.S.")]), _c('span', {
    staticStyle: {
      "font-family": "Georgia",
      "font-size": "1.20em"
    }
  }, [_vm._v("—Will you please return the certificate when you have done with it?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text_Indent_2"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("Here we see our young friend making his old mistakes. In his anxiety to emphasize his assurances, he represents sanitary security as a very difficult and dangerous matter to arrange and a still more difficult matter to prove—which are the particular things he should have avoided. He also depicts himself as persuaded, only, of the purity of Honeywood: he does not, as he should, assert a fact, but reasons his conclusions although he knows that the person he addresses is incapable of reasoning and unable to weigh the evidence if she were. On the top of all this he actually admits the possibility of a defect and, without knowing what that defect may be, pledges his word that it cannot set up unsanitary conditions. It would probably have been better if he had left Brash to open the subject, as he would do were it more than a figment of his lady’s imagination. Why the exasperating fellow cannot hold his tongue, after all he has suffered from unnecessarily wagging it, is beyond understanding. It is inconceivable that there can be anything wrong with the drains, but Spinlove has given his client reason to think it possible.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std_Italic__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Standard__And__Dante_MT_Std_Italic__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd50033e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0007.vue
// module id = 78
// module chunks = 0